// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".languagePickerContainer {\n  width: 100%;\n  margin-bottom: 5%;\n}\n.languagePickerContainer .ant-select {\n  color: #1E70EB;\n}\n.languagePickerContainer .ant-select-open {\n  min-width: 240px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
